module.exports = __webpack_public_path__ + "assets/e001f00825809d61b7aa14d6d89c890e.png";